import ProjectSessionCollection from "../project/collection"
import ProjectSession from "../project/project-session"

export default class ProjectTemplateCollection extends ProjectSessionCollection {

    // do not get from gd.session.templatesList like in ProjectSessionCollection
    get(id: ID):ProjectSession | null {
        return this.byId[id]
    }
}